<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item>首页</el-breadcrumb-item>
			  <el-breadcrumb-item>邀请人列表</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<YqList :list="list" :d_id="d_id"></YqList>
		<div class="fenye" v-if="total>12">
		   <el-pagination
			 background
			 @current-change="handleCurrentChange"
			 :current-page.sync="currentPage1"
			 :page-size="pagecount"
			 layout="total, prev, pager, next ,jumper"
			 :total="total">
		   </el-pagination>
		</div>
	</div>
</template>

<script>
	import {UserCooperate} from "@/api/api.js"
	import YqList from '@/common/YqList.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		YqList  
	  },
	  data() {
	    return {
		    nametype:[
				{name:"承认图"},
				{name:"生产图"}
			],
			typeindex:0,
			currentPage1:"",
			page:1,
			total:"",
			datails:"",
			pagecount:"",
	    }
	  },
	  computed: {
	    d_id() {
	      return this.$route.query.d_id || ''
	    }
	  },
	  mounted() {
	     this.getUserCooperate()
	  },
	  methods: {
		getUserCooperate(){
		   UserCooperate({
			   page:this.page,
			   limit:'12'
		   }).then(res=>{
			   this.total=res.data.data.total
			   this.datails=res.data.data
			   this.pagecount=res.data.data.pass_count
			   this.currentPage1=res.data.data.current_page
			   this.list=res.data.data.data
		   })
		},
		handleCurrentChange(e){
			this.page=e
			this.getUserCooperate()
		},
		qiehuan(index){
			this.typeindex=index
		}
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.fenye{
		width:100%;
		display:flex;
		align-items: center;
		justify-content: center;
		padding-bottom:20px;
	}
</style>